import { ApiService } from '../../../types/api';
import type { ApiHandlerContract } from '../../../types/handlers/api';
import type { ShippingMethodApiBase, ShippingMethodApiResponse } from '../types/shipping-method';

/**
 * A service contract to interact with a specific shipping method via the SparkLayer API.
 */
export interface ShippingMethodApiContract {
  get(): Promise<ShippingMethodApiResponse>;
  update(payload: ShippingMethodApiBase): Promise<ShippingMethodApiResponse>;
  delete(): Promise<void>;
}

/**
 * A service to interact with a specific shipping method via the SparkLayer API.
 */
export class ShippingMethodApi extends ApiService implements ShippingMethodApiContract {
  constructor(
    api: ApiHandlerContract,
    private id: string,
  ) {
    super(api);
  }

  public get(): Promise<ShippingMethodApiResponse> {
    return this.api.proxy({
      method: 'GET',
      path: '/v1/shipping-methods/{id}',
      params: { id: this.id },
    });
  }

  public update(payload: ShippingMethodApiBase): Promise<ShippingMethodApiResponse> {
    return this.api.proxy({
      method: 'PATCH',
      path: '/v1/shipping-methods/{id}',
      params: { id: this.id },
      payload,
    });
  }

  public delete(): Promise<void> {
    return this.api.proxy({
      method: 'DELETE',
      path: '/v1/shipping-methods/{id}',
      params: { id: this.id },
    });
  }
}
